<script>
  import * as restfulService from '../../app/services/restfulService'
  import bus from '@utils/bus'
  import {required} from 'vuelidate/lib/validators'

  export default {
    data () {
      return {
        isSubmitted: false,
        isValid: true,
        form: {
          hash: ''
        },
        certificate: {
          id: '',
          hash: '',
          certificate_url: ''
        }
      }
    },
    validations: {
      form: {
        hash: {required}
      }
    },
    mounted () {
      setTimeout(() => {
        bus.$emit('hide-loader')
      }, 300)
    },
    computed: {
      getCertificateFilePath: function () {
        return this.certificate.certificate_url
      }
    },
    methods: {
      /**
       * Valida na API o hash do certificado fornecido
       */
      onValidate () {
        bus.$emit('show-loader')
        this.isSubmitted = true
        restfulService.get('certificate', 'validate', this.form.hash)
          .then((response) => {
            this.certificate = response
            bus.$emit('hide-loader')
            this.isSubmitted = false
            // Caso a resposta possua o atributo error, o certificado é inválido
            // Uma mensagem de erro é mostrada ao usuário
            if (response.hasOwnProperty('error')) {
              this.isValid = false
            } else {
              this.isValid = true
            }
          })
          .catch(e => {
            bus.$emit('hide-loader')
            this.isSubmitted = false
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div>
        <div class="login-box validate-certificate">
            <figure class="logo">
                <img src="https://urcamp.edu.br/site/img/logos/logo-preto.png" alt="" style="width: 300px;">
            </figure>
            <h1 class="page-title">Validar Certificado</h1>

            <el-card class="el-card__save_form box-card">
                <el-form ref="form"
                         :model="form"
                         label-position="top">
                    <el-form-item label="Código de Validação"
                                  class="is-required"
                                  v-bind:class="{ 'el-form-item--error': $v.form.hash.$error }">
                        <el-input v-model="form.hash"
                                  size="large"
                                  @input="$v.form.hash.$touch()"
                                  @keyup.enter.native="onValidate"/>
                        <div class="el-form-item__error" v-if="$v.form.hash.$error">Esse campo é obrigatório</div>
                    </el-form-item>
                    <el-alert v-if="!certificate.id && !isValid"
                              class="certificate-alert"
                              title="Certificado não encontrado"
                              :closable="false"
                              type="error">
                    </el-alert>
                    <el-alert v-if="certificate.id && isValid"
                              class="certificate-alert"
                              title="Certificado válido"
                              :closable="false"
                              type="success">
                    </el-alert>
                    <el-form-item>
                        <el-button type="primary"
                                   @click="onValidate"
                                   size="large"
                                   :disabled="isSubmitted || $v.form.$invalid">Validar
                        </el-button>
                    </el-form-item>
                </el-form>
            </el-card>
        </div>
        <div id="certificate-content" v-if="getCertificateFilePath && isValid">
            <object :data="getCertificateFilePath"
                    type="application/pdf">
                <embed :src="getCertificateFilePath"
                       type="application/pdf"/>
            </object>
        </div>
    </div>
</template>

<style lang="scss" scoped>

    .validate-certificate {
        .logo,.page-title {
            text-align: center;
        }
    }
    .certificate-alert {
        margin-bottom: 15px !important;
        .el-alert__title {
            font-size: 16px;
            padding: 15px;
        }
    }

    #certificate-content {
        width: 70%;
        margin: 0 auto;
        padding: 25px 0;
        object,
        embed {
            width: 100%;
            height: 900px;
        }
        object {
            border: 1px solid #CCC;
            margin-bottom: 20px;
        }
    }
</style>
